import { AssetType, AssetData } from "../../types/models/AssetBase";

export function getAssetShortName(
  asset: Pick<AssetData, "type" | "code" | "name" | "address" | "tokenId">,
) {
  const codeName =
    asset.code.trim() ||
    asset.name.trim() ||
    asset.address?.trim() ||
    "<unknown>";

  return asset.type === AssetType.NFT && asset.tokenId ?
      `${contract(codeName, 15)} #${contract(asset.tokenId, 10)}`
    : contract(codeName, 26);
}

function contract(text: string, maxLength: number) {
  if (text.length <= maxLength) {
    return text;
  }

  const start = text.slice(0, (maxLength - 3) / 3);
  const end = text.slice(-((maxLength - 3) / 3));
  return `${start}..${end}`;
}
